export const formatDataForForm = data => {
    const dataClone = { ...data, form_permissions: {} }

    if (data?.permissions?.length > 0) {
        data.permissions.forEach(permission => {
            dataClone.form_permissions[permission.permission] = permission.value
        })
    }

    return dataClone
}

export const formatDataForApi = (data, isUpdate = false) => {
    const dataClone = { ...data, permissions: [] }

    for (const [permission, value] of Object.entries(data.form_permissions)) {
        let permissionId = permission
        const permissionData = {
            value,
        }
        if (isUpdate) {
            const existingPermission = data.permissions.find(p => p.permission === permission)
            if (!!existingPermission) {
                permissionData['@id'] = existingPermission['@id']
            } else {
                permissionData.permission = permissionId
            }
        } else {
            permissionData.permission = permissionId
        }

        dataClone.permissions.push(permissionData)
    }

    if (!dataClone.type) {
        dataClone.type = null
    }

    delete dataClone.form_permissions
    delete dataClone['@id']
    delete dataClone['@context']
    delete dataClone['@type']
    delete dataClone.id
    delete dataClone.originId

    return dataClone
}
